import { MenuItem, Select, InputBase } from '@mui/material';
import React from 'react';
import page, { SIZE_PER_PAGE_KEY } from '../../constants/pages/page';

export function PaginationToolbar (props) {
    const {
        sizePerPageList = [
            { text: '10', value: 10 },
            { text: '25', value: 25 },
            { text: '50', value: 50 },
            { text: '100', value: 100 },
        ],
        sizePerPage,
        onSizePerPageChange
    } = props.paginationProps || props;

    const sizeList = sizePerPageList;

    const onSizeChange = event => {
        const newSize = +event.target.value;
        if (onSizePerPageChange) {
            onSizePerPageChange(newSize);
        }
        localStorage.setItem(SIZE_PER_PAGE_KEY, newSize);
    };

    const currentSize = sizePerPage || Number(localStorage.getItem(SIZE_PER_PAGE_KEY)) || page.pageSize;

    return (
        <div className='d-flex align-items-center'>
            <Select
                input={<InputBase className='inputBase' />}
                label={currentSize}
                value={currentSize}
                onChange={onSizeChange}
                className='pagination-select'
                MenuProps={{
                    anchorOrigin: {
                        vertical: 'bottom',
                        horizontal: 'left',
                    },
                    transformOrigin: {
                        vertical: 'top',
                        horizontal: 'left',
                    },
                    getContentAnchorEl: null
                }}
            >
                {sizeList.map(option => {
                    const isSelect = Number(currentSize) === Number(option.value);
                    return (
                        <MenuItem
                            key={option.text}
                            value={option.value}
                            className={`custom-options ${isSelect ? 'custom-options-selected' : ''}`}
                        >
                            {option.text}
                        </MenuItem>
                    );
                })}
            </Select>
        </div>
    );
}
